// extracted by mini-css-extract-plugin
export default {"hero":"hero_hero__aCIO2","contactform":"hero_contactform__nWgJI","svg":"hero_svg__x5eTe","backsvg":"hero_backsvg__F+5wb"};